import { connect } from "react-redux";
import IAppState from "../../../../redux/types/IAppState";
import { MemberStatementUsageDetailsPage } from "./MemberStatementUsageDetailsPage";
import IMembersPortalComponentDataItem from "../../../../redux/types/IMembersPortalComponentDataItem";
import { IMemberStatementUsageDetailsState } from "../../../../redux/types/IMemberStatementState";

export default connect(
    (state: IAppState): {
        usageDetailsPageComponentData: IMembersPortalComponentDataItem;
        usageDetailsGridsComponentData: IMembersPortalComponentDataItem;
        usageDetails: IMemberStatementUsageDetailsState;
        userNameNumber: string;
    } => ({
        usageDetailsPageComponentData: state.membersPortal.componentData.MemberStatementUsageDetailsPage,
        usageDetailsGridsComponentData: state.membersPortal.componentData.MemberStatementUsageDetailsGridsView,
        usageDetails: state.membersPortal.tabs[state.membersPortal.activeTab].memberStatementUsageDetailsState,
        userNameNumber: state.account.currentUserNameNumber
    }),
)(MemberStatementUsageDetailsPage);
